// client-overview translations (Norwegian source catalog).
window.PlummeI18n.register('no', {
  'kov.chip.search': 'Søk: {query}',
  'kov.chip.vatLiable': 'MVA-pliktig: {value}',
  'kov.chip.hasEmployees': 'Har ansatte: {value}',
  'kov.searchClient': 'Søk etter klient',
  'kov.responsible': 'Ansvarlig',
  'kov.allResponsible': 'Alle ansvarlige',
  'kov.status': 'Status',
  'kov.allStatuses': 'Alle statuser',
  'kov.onlyActionNeeded': 'Vis bare klienter som krever handling',
  'kov.moreFilters': 'Flere filtre',
  'kov.resetFilters': 'Nullstill filtre',
  'kov.deadline': 'Frist',
  'kov.allDeadlines': 'Alle frister',
  'kov.next7Days': 'Neste 7 dager',
  'kov.companyType': 'Selskapsform',
  'kov.all': 'Alle',
  'kov.yes': 'Ja',
  'kov.no': 'Nei',
  'kov.vatLiable': 'MVA-pliktig',
  'kov.hasEmployees': 'Har ansatte',
  'kov.title': 'Klientoversikt',
  'kov.subtitle': 'Se hva som krever oppfølging på tvers av klientene dine.',
  'kov.myClients': 'Mine klienter',
  'kov.allClients': 'Alle klienter',
  'kov.refresh': 'Oppdater',
  'kov.emptyTitle': 'Ingen klienter ennå',
  'kov.emptyText': 'Klientene dukker opp her så snart de aksepterer oppdraget. Send en forespørsel fra Klienter under Øvrig.',
  'kov.kpi.needsAction': 'Krever handling',
  'kov.kpi.waitingForCustomer': 'Venter på kunde',
  'kov.kpi.deadline7': 'Frist neste 7 dager',
  'kov.kpi.deadlinePassed': 'Frist passert',
  'kov.kpi.readyForReview': 'Klar til kontroll',
  'kov.kpi.needsActionHelp': 'Teller unike klienter, ikke antall varsler.',
  'kov.showing': 'Viser:',
  'kov.removeFilter': 'Fjern filter',
  'kov.sortBy': 'Sorter etter',
  'kov.noMatchTitle': 'Ingen klienter passer med filtrene',
  'kov.noMatchText': 'Prøv å endre søket eller nullstill filtrene.',
});
